import React, { useState, useRef, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useCountry } from './../CountryContext';
import Custom_Calendar from "../../components/Custom_Calender";

const Dropdown = ({ type, value, options, onSelect, countryValue }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownMenuRef = useRef(null);
    const contentRef = useRef(null);
    const thumbRef = useRef(null);
    const [thumbHeight, setThumbHeight] = useState(20);
    const [scrollTop, setScrollTop] = useState(0);
    const [isDragging, setIsDragging] = useState(false);
    const [selectedItems, setSelectedItems] = useState({});
  
    // Define all possible options
    const allOptions = {
       
        CROPS: [
            { id: "african-night-shade", name: "African Night Shade", value: "african-night-shade" },
            { id: "alovera", name: "Alovera", value: "alovera" },
            { id: "avocados", name: "Avocados", value: "avocados" },
            { id: "apple", name: "Apple", value: "apple" },
            { id: "bananas", name: "Bananas", value: "bananas" },
            { id: "baobab", name: "Baobab", value: "baobab" },
            { id: "beans", name: "Beans", value: "beans" },
            { id: "beetroot", name: "Beetroot", value: "beetroot" },
            { id: "black-nightshade", name: "Black Nightshade", value: "black-nightshade" },
            { id: "cabbage", name: "Cabbage", value: "cabbage" },
            { id: "capsicum", name: "Capsicum", value: "capsicum" }
        ],
        LIVESTOCK: [
            { id: "bees", name: "Bees", value: "bees" },
            { id: "cattle-dairy", name: "Cattle - Dairy", value: "cattle-dairy" },
            { id: "fish", name: "Fish", value: "fish" },
            { id: "catfish", name: "Catfish", value: "catfish" }
        ],
        FOREST: [
            { id: "bamboo", name: "Bamboo", value: "bamboo" },
            { id: "blue-gum", name: "Blue Gum", value: "blue-gum" }
        ]
    };
  
    // Get the correct options based on dropdown type
    const dropdownOptions = allOptions[type] || options || [];
  
    const capitalizeWords = (str) => {
        if (!str) return "";
        return str
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(" ");
    };
  
    const getDisplayValue = () => {
        if (value) {
            if (type === "COUNTRY") return value.name || "-";
            return value.name || value.value || "-";
        }
        return "-";
    };
  
    const getHeaderTitle = () => {
        switch (type) {
            case "COUNTRY":
                return "Countries";
            case "REGION":
                return "Regions";
            case "DISTRICT":
                return "Districts";
            case "MUNICIPALITY":
                return "Municipalities";
            case "SMMEs":
                return "SMMEs";
            case "VALUE CHAIN":
                return "Value Chains";
            case "PROJECT":
                return "Projects";
            case "USER TYPE":
                return "User Types";
            case "SERVICES":
                return "Services";
            case "CROPS":
                return "Crops";
            case "LIVESTOCK":
                return "Livestock";
            case "FOREST":
                return "Forest";
            default:
                return "Select Option";
        }
    };
  
    const toggleItemSelection = (itemId) => {
        setSelectedItems(prev => ({
            ...prev,
            [itemId]: !prev[itemId]
        }));
    };
  
    const renderRegularItems = () => {
        return dropdownOptions?.map((option, index) => (
            <li
                key={index}
                className={`group flex items-center justify-between px-3 py-2 text-sm cursor-pointer hover:bg-[#2E453D] transition-colors duration-200 rounded ${
                    selectedItems[option.id] ? "bg-[#2E453D]" : ""
                }`}
            >
                <span 
                    className="text-white"
                    onClick={(e) => {
                        e.stopPropagation();
                        onSelect(option);
                        setIsOpen(false);
                    }}
                >
                    {option.name || option.value}
                </span>
                <button 
                    onClick={(e) => {
                        e.stopPropagation();
                        toggleItemSelection(option.id);
                    }}
                >
                    {selectedItems[option.id] ? <SelectedIcon /> : <UnselectedIcon />}
                </button>
            </li>
        ));
    };
  
    const renderGroupedItems = () => {
      return (
        <div className="mb-2">
          {/* Always show all sections */}
          <h4 className="text-white font-bold px-3 py-1 bg-[#2E453D]/50">CROPS</h4>
          <ul>
            {allOptions.CROPS.map((item, index) => (
              <li
                key={`crop-${index}`}
                className={`group flex items-center justify-between px-3 py-2 text-sm text-white cursor-pointer hover:bg-[#2E453D] transition-colors duration-200 rounded ${
                  selectedItems[item.id] ? "bg-[#2E453D]" : ""
                }`}
              >
                <span 
                  onClick={(e) => {
                    e.stopPropagation();
                    onSelect(item);
                    setIsOpen(false);
                  }}
                >
                  {item.name}
                </span>
                <button 
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleItemSelection(item.id);
                  }}
                >
                  {selectedItems[item.id] ? <SelectedIcon /> : <UnselectedIcon />}
                </button>
              </li>
            ))}
          </ul>
    
          <h4 className="text-white font-bold px-3 py-1 bg-[#2E453D]/50 mt-2">LIVESTOCK</h4>
          <ul>
            {allOptions.LIVESTOCK.map((item, index) => (
              <li
                key={`livestock-${index}`}
                className={`group flex items-center justify-between px-3 py-2 text-sm text-white cursor-pointer hover:bg-[#2E453D] transition-colors duration-200 rounded ${
                  selectedItems[item.id] ? "bg-[#2E453D]" : ""
                }`}
              >
                <span 
                  onClick={(e) => {
                    e.stopPropagation();
                    onSelect(item);
                    setIsOpen(false);
                  }}
                >
                  {item.name}
                </span>
                <button 
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleItemSelection(item.id);
                  }}
                >
                  {selectedItems[item.id] ? <SelectedIcon /> : <UnselectedIcon />}
                </button>
              </li>
            ))}
          </ul>
    
          <h4 className="text-white font-bold px-3 py-1 bg-[#2E453D]/50 mt-2">FOREST</h4>
          <ul>
            {allOptions.FOREST.map((item, index) => (
              <li
                key={`forest-${index}`}
                className={`group flex items-center justify-between px-3 py-2 text-sm text-white cursor-pointer hover:bg-[#2E453D] transition-colors duration-200 rounded ${
                  selectedItems[item.id] ? "bg-[#2E453D]" : ""
                }`}
              >
                <span 
                  onClick={(e) => {
                    e.stopPropagation();
                    onSelect(item);
                    setIsOpen(false);
                  }}
                >
                  {item.name}
                </span>
                <button 
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleItemSelection(item.id);
                  }}
                >
                  {selectedItems[item.id] ? <SelectedIcon /> : <UnselectedIcon />}
                </button>
              </li>
            ))}
          </ul>
        </div>
      );
    };
  
    const UnselectedIcon = () => (
      <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8.5" cy="8.5" r="8" fill="#D9D9D9" stroke="none"/>
      </svg>
    );
    
    const SelectedIcon = () => (
      <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8.5" cy="8.5" r="8" fill="#2E453D" stroke="#FFBD26"/>
        <path d="M5 8.5L7.5 11L12 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    );
  
    const handleScroll = () => {
      if (!contentRef.current) return;
      const { scrollTop, scrollHeight, clientHeight } = contentRef.current;
      setScrollTop(scrollTop);
      
      const thumbH = Math.max(
        (clientHeight / scrollHeight) * clientHeight,
        20
      );
      setThumbHeight(thumbH);
    };
  
    const handleTrackClick = (e) => {
      if (!contentRef.current || !thumbRef.current) return;
      const trackRect = e.currentTarget.getBoundingClientRect();
      const thumbOffset = e.clientY - trackRect.top - thumbHeight / 2;
      const scrollPercentage = thumbOffset / (trackRect.height - thumbHeight);
      contentRef.current.scrollTop =
        scrollPercentage * (contentRef.current.scrollHeight - contentRef.current.clientHeight);
    };
  
    const handleThumbMouseDown = (e) => {
      e.preventDefault();
      setIsDragging(true);
      
      const startY = e.clientY;
      const startScrollTop = scrollTop;
      
      const handleMouseMove = (e) => {
        if (!isDragging || !contentRef.current) return;
        const deltaY = e.clientY - startY;
        const trackHeight = contentRef.current.clientHeight - thumbHeight;
        const scrollDelta = (deltaY / trackHeight) * contentRef.current.scrollHeight;
        contentRef.current.scrollTop = startScrollTop + scrollDelta;
      };
      
      const handleMouseUp = () => {
        setIsDragging(false);
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
      };
      
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
    };
  
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropdownMenuRef.current && !dropdownMenuRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);
  
    useEffect(() => {
      if (contentRef.current) {
        handleScroll();
      }
    }, [isOpen, options]);
  
    return (
        <div className="relative md:mr-4 mr-2" ref={dropdownMenuRef}>
        <button
          className={`relative xl:w-[205px] lg:w-[160px] md:w-[100px] w-[70px] h-[20px] md:h-[53px] bg-[#2E453D] text-white flex justify-between items-center text-[8px] md:text-[17px] px-[2px] rounded-[4px] truncate`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className={`whitespace-normal break-words font-normal leading-[0.90] text-center capitalize w-full ${
            getDisplayValue() === "-" ? "text-gray-400" : ""
          }`}>
            {capitalizeWords(getDisplayValue())}
          </span>
          
          <span className="absolute bottom-[1px] right-3 text-[6px] md:text-[8px] text-white">
            {(type === "COUNTRY" && value?.code) || 
             (type === "REGION" && value?.value) || 
             (type === "DISTRICT" && value?.value) || 
             (type === "SMMEs" && value?.value) || 
             '-'}
          </span>
          
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1751799445/Expand_down_light_syoynq.png"
            alt="expand"
            className="absolute bottom-2 right-2 w-2 h-2 md:w-5 md:h-5"
          />
        </button>
  
     
        <AnimatePresence>
                  {isOpen && (
                      <motion.div
                          initial={{ opacity: 0, height: 0 }}
                          animate={{ opacity: 1, height: "auto" }}
                          exit={{ opacity: 0, height: 0 }}
                          transition={{ duration: 0.2, ease: "easeInOut" }}
                          className="bg-[#2E453D]/80 rounded-b-[5px] overflow-x-auto backdrop-blur-sm absolute top-full mt-1 left-0 w-full z-50 md:w-[205px]"
                      >
                          <div className="px-3 py-2">
                              <div className="flex items-center justify-between mb-2">
                                  <h3 className="text-white text-sm font-semibold">
                                      {getHeaderTitle()}
                                  </h3>
                                  <img 
                                      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1750628487/Export_light_kuxwb6.png" 
                                      alt="Export icon"
                                      className="w-4 h-4 ml-2 cursor-pointer"
                                      onClick={(e) => {
                                          e.stopPropagation();
                                          setIsOpen(false);
                                      }}
                                  />
                              </div>
                              <div className="custom-scroll-area max-h-[200px]">
                                  <div
                                      className="custom-scroll-content"
                                      ref={contentRef}
                                      onScroll={handleScroll}
                                  >
                                      <ul className="space-y-2">
                                          {type === "CROPS" || type === "LIVESTOCK" || type === "FOREST"
                                              ? renderGroupedItems()
                                              : renderRegularItems()}
                                      </ul>
                                  </div>
                                  {/* ... scroll track code ... */}
                              </div>
                          </div>
                      </motion.div>
                  )}
              </AnimatePresence>
      </div>
    );
  };
  const Dropdown1 = ({ type, value, options, onSelect, countryValue }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownMenuRef = useRef(null);
    const contentRef = useRef(null);
    const thumbRef = useRef(null);
    const [thumbHeight, setThumbHeight] = useState(20);
    const [scrollTop, setScrollTop] = useState(0);
    const [isDragging, setIsDragging] = useState(false);
    const [selectedItems, setSelectedItems] = useState({});
  
    // Define all possible options
    const allOptions = {
       
        CROPS: [
            { id: "african-night-shade", name: "African Night Shade", value: "african-night-shade" },
            { id: "alovera", name: "Alovera", value: "alovera" },
            { id: "avocados", name: "Avocados", value: "avocados" },
            { id: "apple", name: "Apple", value: "apple" },
            { id: "bananas", name: "Bananas", value: "bananas" },
            { id: "baobab", name: "Baobab", value: "baobab" },
            { id: "beans", name: "Beans", value: "beans" },
            { id: "beetroot", name: "Beetroot", value: "beetroot" },
            { id: "black-nightshade", name: "Black Nightshade", value: "black-nightshade" },
            { id: "cabbage", name: "Cabbage", value: "cabbage" },
            { id: "capsicum", name: "Capsicum", value: "capsicum" }
        ],
        LIVESTOCK: [
            { id: "bees", name: "Bees", value: "bees" },
            { id: "cattle-dairy", name: "Cattle - Dairy", value: "cattle-dairy" },
            { id: "fish", name: "Fish", value: "fish" },
            { id: "catfish", name: "Catfish", value: "catfish" }
        ],
        FOREST: [
            { id: "bamboo", name: "Bamboo", value: "bamboo" },
            { id: "blue-gum", name: "Blue Gum", value: "blue-gum" }
        ]
    };
  
    // Get the correct options based on dropdown type
    const dropdownOptions = allOptions[type] || options || [];
  
    const capitalizeWords = (str) => {
        if (!str) return "";
        return str
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(" ");
    };
  
    const getDisplayValue = () => {
        if (value) {
            if (type === "COUNTRY") return value.name || "-";
            return value.name || value.value || "-";
        }
        return "-";
    };
  
    const getHeaderTitle = () => {
        switch (type) {
            case "COUNTRY":
                return "Countries";
            case "REGION":
                return "Regions";
            case "DISTRICT":
                return "Districts";
            case "MUNICIPALITY":
                return "Municipalities";
            case "SMMEs":
                return "SMMEs";
            case "VALUE CHAIN":
                return "Value Chains";
            case "PROJECT":
                return "Projects";
            case "USER TYPE":
                return "User Types";
            case "SERVICES":
                return "Services";
            case "CROPS":
                return "Crops";
            case "LIVESTOCK":
                return "Livestock";
            case "FOREST":
                return "Forest";
            default:
                return "Select Option";
        }
    };
  
    const toggleItemSelection = (itemId) => {
        setSelectedItems(prev => ({
            ...prev,
            [itemId]: !prev[itemId]
        }));
    };
  
    const renderRegularItems = () => {
        return dropdownOptions?.map((option, index) => (
            <li
                key={index}
                className={`group flex items-center justify-between px-3 py-2 text-sm cursor-pointer hover:bg-[#2E453D] transition-colors duration-200 rounded ${
                    selectedItems[option.id] ? "bg-[#2E453D]" : ""
                }`}
            >
                <span 
                    className="text-white"
                    onClick={(e) => {
                        e.stopPropagation();
                        onSelect(option);
                        setIsOpen(false);
                    }}
                >
                    {option.name || option.value}
                </span>
                <button 
                    onClick={(e) => {
                        e.stopPropagation();
                        toggleItemSelection(option.id);
                    }}
                >
                    {selectedItems[option.id] ? <SelectedIcon /> : <UnselectedIcon />}
                </button>
            </li>
        ));
    };
  
    const renderGroupedItems = () => {
      return (
        <div className="mb-2">
          {/* Always show all sections */}
          <h4 className="text-white font-bold px-3 py-1 bg-[#2E453D]/50">CROPS</h4>
          <ul>
            {allOptions.CROPS.map((item, index) => (
              <li
                key={`crop-${index}`}
                className={`group flex items-center justify-between px-3 py-2 text-sm text-white cursor-pointer hover:bg-[#2E453D] transition-colors duration-200 rounded ${
                  selectedItems[item.id] ? "bg-[#2E453D]" : ""
                }`}
              >
                <span 
                  onClick={(e) => {
                    e.stopPropagation();
                    onSelect(item);
                    setIsOpen(false);
                  }}
                >
                  {item.name}
                </span>
                <button 
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleItemSelection(item.id);
                  }}
                >
                  {selectedItems[item.id] ? <SelectedIcon /> : <UnselectedIcon />}
                </button>
              </li>
            ))}
          </ul>
    
          <h4 className="text-white font-bold px-3 py-1 bg-[#2E453D]/50 mt-2">LIVESTOCK</h4>
          <ul>
            {allOptions.LIVESTOCK.map((item, index) => (
              <li
                key={`livestock-${index}`}
                className={`group flex items-center justify-between px-3 py-2 text-sm text-white cursor-pointer hover:bg-[#2E453D] transition-colors duration-200 rounded ${
                  selectedItems[item.id] ? "bg-[#2E453D]" : ""
                }`}
              >
                <span 
                  onClick={(e) => {
                    e.stopPropagation();
                    onSelect(item);
                    setIsOpen(false);
                  }}
                >
                  {item.name}
                </span>
                <button 
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleItemSelection(item.id);
                  }}
                >
                  {selectedItems[item.id] ? <SelectedIcon /> : <UnselectedIcon />}
                </button>
              </li>
            ))}
          </ul>
    
          <h4 className="text-white font-bold px-3 py-1 bg-[#2E453D]/50 mt-2">FOREST</h4>
          <ul>
            {allOptions.FOREST.map((item, index) => (
              <li
                key={`forest-${index}`}
                className={`group flex items-center justify-between px-3 py-2 text-sm text-white cursor-pointer hover:bg-[#2E453D] transition-colors duration-200 rounded ${
                  selectedItems[item.id] ? "bg-[#2E453D]" : ""
                }`}
              >
                <span 
                  onClick={(e) => {
                    e.stopPropagation();
                    onSelect(item);
                    setIsOpen(false);
                  }}
                >
                  {item.name}
                </span>
                <button 
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleItemSelection(item.id);
                  }}
                >
                  {selectedItems[item.id] ? <SelectedIcon /> : <UnselectedIcon />}
                </button>
              </li>
            ))}
          </ul>
        </div>
      );
    };
  
    const UnselectedIcon = () => (
      <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8.5" cy="8.5" r="8" fill="#D9D9D9" stroke="none"/>
      </svg>
    );
    
    const SelectedIcon = () => (
      <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8.5" cy="8.5" r="8" fill="#2E453D" stroke="#FFBD26"/>
        <path d="M5 8.5L7.5 11L12 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    );
  
    const handleScroll = () => {
      if (!contentRef.current) return;
      const { scrollTop, scrollHeight, clientHeight } = contentRef.current;
      setScrollTop(scrollTop);
      
      const thumbH = Math.max(
        (clientHeight / scrollHeight) * clientHeight,
        20
      );
      setThumbHeight(thumbH);
    };
  
    const handleTrackClick = (e) => {
      if (!contentRef.current || !thumbRef.current) return;
      const trackRect = e.currentTarget.getBoundingClientRect();
      const thumbOffset = e.clientY - trackRect.top - thumbHeight / 2;
      const scrollPercentage = thumbOffset / (trackRect.height - thumbHeight);
      contentRef.current.scrollTop =
        scrollPercentage * (contentRef.current.scrollHeight - contentRef.current.clientHeight);
    };
  
    const handleThumbMouseDown = (e) => {
      e.preventDefault();
      setIsDragging(true);
      
      const startY = e.clientY;
      const startScrollTop = scrollTop;
      
      const handleMouseMove = (e) => {
        if (!isDragging || !contentRef.current) return;
        const deltaY = e.clientY - startY;
        const trackHeight = contentRef.current.clientHeight - thumbHeight;
        const scrollDelta = (deltaY / trackHeight) * contentRef.current.scrollHeight;
        contentRef.current.scrollTop = startScrollTop + scrollDelta;
      };
      
      const handleMouseUp = () => {
        setIsDragging(false);
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
      };
      
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
    };
  
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropdownMenuRef.current && !dropdownMenuRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);
  
    useEffect(() => {
      if (contentRef.current) {
        handleScroll();
      }
    }, [isOpen, options]);
  
    return (
        <div className="relative md:mr-4 mr-2" ref={dropdownMenuRef}>
        <button
          className={`relative xl:w-[250px] lg:w-[160px] md:w-[100px] w-[70px] h-[20px] md:h-[53px] bg-[#2E453D] text-white flex justify-between items-center text-[8px] md:text-[17px] px-[2px] rounded-[4px] truncate`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className={`whitespace-normal break-words font-normal leading-[0.90] text-center capitalize w-full ${
            getDisplayValue() === "-" ? "text-gray-400" : ""
          }`}>
            {capitalizeWords(getDisplayValue())}
          </span>
          
          <span className="absolute bottom-[1px] right-3 text-[6px] md:text-[8px] text-white">
            {(type === "COUNTRY" && value?.code) || 
             (type === "REGION" && value?.value) || 
             (type === "DISTRICT" && value?.value) || 
             (type === "SMMEs" && value?.value) || 
             '-'}
          </span>
          
  
        </button>
  
        <div
          className={`w-[16px] md:w-[50px] h-[20px] md:h-[53px] "
          } flex justify-center items-center rounded-r-[4px] -ml-1 z-50`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745014174/Expand_down_3_ggzyur.png"
            alt="expand"
            className="w-2 h-2 md:w-5 md:h-[24px]"
          />
        </div>
        <AnimatePresence>
                  {isOpen && (
                      <motion.div
                          initial={{ opacity: 0, height: 0 }}
                          animate={{ opacity: 1, height: "auto" }}
                          exit={{ opacity: 0, height: 0 }}
                          transition={{ duration: 0.2, ease: "easeInOut" }}
                          className="bg-[#2E453D]/80 rounded-b-[5px] overflow-x-auto backdrop-blur-sm absolute top-full mt-1 left-0 w-full z-50 md:w-[205px]"
                      >
                          <div className="px-3 py-2">
                              <div className="flex items-center justify-between mb-2">
                                  <h3 className="text-white text-sm font-semibold">
                                      {getHeaderTitle()}
                                  </h3>
                                  <img 
                                      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1750628487/Export_light_kuxwb6.png" 
                                      alt="Export icon"
                                      className="w-4 h-4 ml-2 cursor-pointer"
                                      onClick={(e) => {
                                          e.stopPropagation();
                                          setIsOpen(false);
                                      }}
                                  />
                              </div>
                              <div className="custom-scroll-area max-h-[200px]">
                                  <div
                                      className="custom-scroll-content"
                                      ref={contentRef}
                                      onScroll={handleScroll}
                                  >
                                      <ul className="space-y-2">
                                          {type === "CROPS" || type === "LIVESTOCK" || type === "FOREST"
                                              ? renderGroupedItems()
                                              : renderRegularItems()}
                                      </ul>
                                  </div>
                                  {/* ... scroll track code ... */}
                              </div>
                          </div>
                      </motion.div>
                  )}
              </AnimatePresence>
      </div>
    );
  };
const Calendar = () => {
 const { selectedCountry } = useCountry();
     const [selectedService, setSelectedService] = useState(null);
  return (
    <div className='bg-white'>
    <div className='md:px-24 px-4 md:pt-4 '>
    <div className="flex justify-between items-center">
          <h2 className="md:text-[36px] text-[10px] capitalize text-[#152C24] font-bold">
            <span className="text-[#979797] capitalize">CALENDER | </span>{selectedCountry?.name || 'South Africa'}
          </h2>
          <div>
            <h1 className="md:text-[20px] text-[8px] font-extrabold md:mb-2">USER NUMBER</h1>
            <div className="flex w-fit">
              <button
                className={`xl:w-[250px] lg:w-[160px] md:w-[90px] w-[70px] h-[25px] md:h-[53px] bg-[#152C24] text-white font-medium flex items-center px-1 rounded-l-[5px]`}>
                <input className="md:text-[18px] text-[8px] md:px-2 bg-transparent outline-none placeholder-white" placeholder="XXXXXXXXX"/>
              </button>
              <div
                className="w-[20px] h-[25px] md:h-[53px] md:w-[50px] bg-[#EEB527] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer"
              >
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747251939/Expand_right_wbmjno.png"
                  alt="expand"
                  className="w-3 h-[12px] md:w-6 md:h-[24px]"
                />
              </div>
            </div>
            <p className="md:text-[14px] text-[8px] font-normal mt-1 text-black">
              Insert ID Number
            </p>
          </div>
        </div>     
         <div className="flex flex-col md:flex-row items-center w-full md:mb-4 md:mt-6 my-3 gap-2 md:gap-12">
                <Dropdown 
    type="CROPS"  // Add this prop to specify which options to show
    value={selectedService} 
    onSelect={(option) => setSelectedService(option)}
/>
                    
                    <div className="flex-1 w-full relative">
                        <input
                            placeholder="Search"
                            type="text"
                            className="w-full h-[30px] md:h-[61px] text-[#979797] text-[10px] md:text-[16px] font-semibold p-2 pr-8 md:p-3 md:px-6 border border-[#C4C4C4] rounded-md focus:outline-none focus:ring-2 focus:ring-green-600"
                        />
                        <img
                            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744490602/Search_k7vxkr.png"
                            alt="Search Icon"
                            className="w-[14px] h-[14px] md:h-[24px] md:w-[24px] absolute right-3 top-1/2 transform -translate-y-1/2"
                        />
                    </div>
                </div>
                <hr/>
                <div className="flex justify-between items-center md:mt-5 mt-2">
          <h2 className="md:text-[36px] text-[10px] capitalize text-[#152C24] font-bold">
          Calender
          </h2>
          <div>
          <Dropdown1 
    type="CROPS"  // Add this prop to specify which options to show
    value={selectedService} 
    onSelect={(option) => setSelectedService(option)}
/>
<p className="md:text-[14px] text-[8px] font-normal mt-1 text-black">
Click to select activity / even
            </p>
          </div>
        </div>     
    <Custom_Calendar/>
    </div>
    </div>
  )
}

export default Calendar